import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:solutions.apps.stm',
    'resource:solutions.apps.stm.pages.chat',
    'resource:solutions.agents.stm',
    'resource:solutions.agents.stmUnitTesting',
  ],
  description: 'Stm',
  name: 'STM',
} as const satisfies core.quiver.Package
